import { createProvider } from '@frontend/store';
import { CreateFormStepsStore, CreateFormStepsStoreState } from './type';

const INITIAL_STATE: CreateFormStepsStoreState = {
  selectedLocationIds: [],
  isCreatingForm: false,
  areUsageTermsAccepted: false,
};

export const { Provider: CreateFormStepsStoreProvider, useStore: useCreateFormStepsStore } =
  createProvider<CreateFormStepsStore>()((set) => ({
    ...INITIAL_STATE,
    setSelectedLocationIds: (ids) => set({ selectedLocationIds: ids }),
    setIsCreatingForm: (isCreatingForm) => set({ isCreatingForm }),
    setAreUsageTermsAccepted: (areUsageTermsAccepted) => set({ areUsageTermsAccepted }),

    resetState: () =>
      set({
        selectedLocationIds: [],
        areUsageTermsAccepted: false,
      }),
  }));
